module.exports = __webpack_public_path__ + "audio/fiveAudio.42bf09d6.mp3";